import { T, C } from '@homeschooling/sdk'

import * as React from 'react'
import * as _ from 'lodash'

import m from 'moment'

import defaultAva from '../../Components/brand/default_ava.svg'
import { Helper } from '../../Components/Helpers'

import Persistance from "../Persistence";

export interface Props {
    children?: React.ReactNode
    expense: T.Expense
    position: number
}
  
export interface State {
    students: T.Student[],
    focus: boolean
}

Persistance.setValues()

export class ExpenseRow extends React.Component<Props, any> {

    public constructor (props: Props) {
        super(props)
    
        this.state = {
          students: Persistance.getStudents(),
          focus: false
        }
      }

    public showExpense = () => {
        this.setState({focus: true})
    }

    public getStudentFromId = (id: string | number) => {

        return _.find(this.state.students, {id: Number(id)})

    }
  

  public render(): React.ReactNode {
    const expense = this.props.expense
    const student = expense.students ? expense.students[0] : {name: ''}

    const background = this.props.position % 2 === 0 ? '' : 'bg-slate-100'

    return (
      <div id={`expense_${expense.id}`} className={`flex text-main items-center flex-row justify-left h-auto ${background} hover:bg-slate-300 py-3`}>
        <div className='w-12 flex flex-row items-center text-left text-xs flex-none'>
          <div className='w-12 items-center flex-none pr-2'>
            <div className='flex items-center flex-none h-auto'>
              <img title= {student.name} alt={student.name} className="object-cover w-8 h-8 rounded-full" src={defaultAva} />
            </div>
          </div>
        </div>  
        <div className='w-12 grow text-left flex-none align-middle text-gray-600 text-s px-2'>
           {expense.description}
        </div>
        <div className='w-44 text-left text-sm flex-none text-ellipsis align-middle overflow-hidden '>
          {expense.paid_to}
        </div>
        <div className='w-36 text-left text-sm align-middle flex-none'>
        {C.industry[expense.category].label}
        </div>
        <div className='w-24 h-auto text-center align-middle text-left px-2 flex-none'>
            {Helper.formatMoney(expense.price)}
        </div>
        <div className='w-28 text-center text-sm align-middle flex-none'>
          {m(expense.date).format('MMM DD YYYY')}
        </div>
    </div>
    )
  }  
  
}

export default ExpenseRow